import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/modules/auth/ProtectedRoute';
import PortalGatekeeper from '@/modules/common/components/PortalGatekeeper';
import PlaceholderPage from '@/modules/common/components/PlaceholderPage';

const MiOrganizacionPage = React.lazy(() => import('@/modules/corporation/perfil/MiOrganizacionPage'));

const G = ({ children }) => (
  <PortalGatekeeper roleName="corporate" portalDashboardPath="/corporacion/dashboard">
    {children}
  </PortalGatekeeper>
);

export const corporationRoutes = [
  <Route key="/corporacion/dashboard" path="/corporacion/dashboard" element={
    <ProtectedRoute requiredPermission="corporation.portal.view">
      <G><PlaceholderPage title="Dashboard Corporativo" description="Panel de control de la organizacion" /></G>
    </ProtectedRoute>
  } />,
  <Route key="/corporacion/organizacion" path="/corporacion/organizacion" element={
    <ProtectedRoute requiredPermission="corporation.portal.view">
      <G><MiOrganizacionPage /></G>
    </ProtectedRoute>
  } />,
  <Route key="/corporacion/participantes" path="/corporacion/participantes" element={
    <ProtectedRoute requiredPermission="corporation.portal.view">
      <G><PlaceholderPage title="Gestion de Participantes" description="Gestion de participantes de la organizacion" /></G>
    </ProtectedRoute>
  } />,
  <Route key="/corporacion/seguimiento" path="/corporacion/seguimiento" element={
    <ProtectedRoute requiredPermission="corporation.portal.view">
      <G><PlaceholderPage title="Seguimiento" description="Seguimiento de programas y participantes" /></G>
    </ProtectedRoute>
  } />,
  <Route key="/corporacion/reportes" path="/corporacion/reportes" element={
    <ProtectedRoute requiredPermission="corporation.portal.view">
      <G><PlaceholderPage title="Reportes" description="Reportes y estadisticas de la organizacion" /></G>
    </ProtectedRoute>
  } />,
  <Route key="/corporacion/comunicacion" path="/corporacion/comunicacion" element={
    <ProtectedRoute requiredPermission="corporation.portal.view">
      <G><PlaceholderPage title="Comunicacion" description="Comunicacion con la institucion" /></G>
    </ProtectedRoute>
  } />,
];
